// extracted by mini-css-extract-plugin
export var background = "_ip-6";
export var containerMedium = "_ip-0";
export var containerMicro = "_ip-2";
export var containerSmall = "_ip-1";
export var dropdown = "_ip-5";
export var dropdownLabel = "_ip-a";
export var enter = "_ip-7";
export var exitActive = "_ip-8";
export var label = "_ip-3";
export var option = "_ip-9";
export var select = "_ip-4";